// extracted by mini-css-extract-plugin
export default {"noMatch":"GdnP4lOjAv1378_2gq7m"};